import type { Variant } from '@velasca/types'

/**
 * A hover bar must only be shown for the variant currently under the pointer,
 * and never for the already-selected variant (which already shows its own
 * stronger "selected" underline).
 */
export const shouldShowHoverBar = (
  hoveredVariant: Variant | undefined,
  selectedVariant: Variant,
  variant: Variant,
): boolean => {
  if (!hoveredVariant) {
    return false
  }

  return (
    hoveredVariant.id === variant.id && hoveredVariant.id !== selectedVariant.id
  )
}
